import { useEffect } from "react";

export type UseScriptProps = {
  id?: string;
  onLoad?: () => void;
  src: string;
};

type ScriptState = {
  loaded: boolean;
  script: HTMLScriptElement;
};

// Record to keep track of already loading or loaded scripts, keyed by their src.
const scripts: Record<string, ScriptState> = {};

export const useScript = ({ id, onLoad: onLoadProps, src }: UseScriptProps) => {
  useEffect(() => {
    let scriptState: ScriptState = scripts[src];

    if (!scriptState) {
      const script = document.createElement("script");

      scriptState = {
        loaded: false,
        script
      };

      scripts[src] = scriptState;

      if (id) {
        script.id = id;
      }

      script.async = true;
      script.src = src;

      document.head.appendChild(script);
    }

    if (scriptState.loaded) {
      onLoadProps?.();
    } else {
      const onLoad = () => {
        scriptState.loaded = true;
        onLoadProps?.();
      };

      scriptState.script.addEventListener("load", onLoad);

      return () => {
        scriptState.script.removeEventListener("load", onLoad);
      };
    }
  }, [id, onLoadProps, src]);
};
